import { collectionPath, defineModelSpec, orderBy } from '@elara/firebolt/shared';

import { DestinationSchema } from './schemas/destination-schemas.js';
import { id } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for the destinations collection.
 * It defines the path (`destinations/{id}`) and the data shape for a destination document.
 * Destinations represent travel locations with rich content including
 * attractions, climate information, and travel tips.
 */
export const DestinationModelSpec = defineModelSpec({
  path: collectionPath`destinations/${id}`,
  shape: DestinationSchema.shape,
  constraints: [orderBy('name')],
});

export type DestinationModelSpec = typeof DestinationModelSpec;
